module.exports = __webpack_public_path__ + "img/extra.28bc0450.webp";